import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  EmployerDataResp,
  VacancyArgs,
  VacancyListResp,
  VacancyResp,
} from "./headHunter.types";

/**
 * Идентификатор работодателя в базе HeadHunter
 */
const employerId = 745654;

export const headHunterApi = createApi({
  reducerPath: "HeadHunterApi",

  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.hh.ru/",
  }),

  endpoints: builder => ({
    getEmployerData: builder.query<EmployerDataResp, void>({
      query: () => {
        return {
          url: `/employers/${employerId}`,
        };
      },
    }),
    getVacancyList: builder.query<VacancyListResp, void>({
      query: () => {
        return {
          url: `/vacancies?employer_id=${employerId}`,
        };
      },
    }),
    getVacancy: builder.query<VacancyResp, VacancyArgs>({
      query: args => {
        return {
          url: `https://api.hh.ru/vacancies/${args.vacancy_id}`,
          params: args,
        };
      },
    }),
  }),
});
